import { discoverCTPETPairs } from './suvDiscovery';
import { computePetVoxelVolumeMm3 } from './petVoxelVolume';
import { makeSuvKey, setSuvStats, makeNeStats } from './suvStore';
import { deleteSuvSamples } from './suvSampleCache';
import { computeAndStoreRoiSuv } from './computeAndStoreRoiSuv';

export default async function computeRoiSuvForPairs({
  imageSets,
  getStructureSet,
  structureSetUID,
  roiNumbers,
}) {
  if (!roiNumbers?.length) return;

  const pair = discoverCTPETPairs(imageSets)
    .find(p => p.structureSetUID === structureSetUID);
  if (!pair) return;
  const { ctSeriesUID, ctImageIds, petImageIds } = pair;

  if (!pair.frameofRefOk) {
    for (const roiNumber of roiNumbers) {
      const key = makeSuvKey(structureSetUID, roiNumber, ctSeriesUID);
      deleteSuvSamples(key);
      setSuvStats(key, makeNeStats('for-mismatch'));
    }
    return;
  }

  const rois = getStructureSet(structureSetUID)?.ROIContours || [];
  const byNumber = new Map(rois.map(r => [r.ROINumber, r]));

  const petVoxelVolumeMm3 = computePetVoxelVolumeMm3(petImageIds);
  for (const roiNumber of roiNumbers) {
    const roi = byNumber.get(roiNumber);
    if (!roi) {
      const key = makeSuvKey(structureSetUID, roiNumber, ctSeriesUID);
      deleteSuvSamples(key);
      setSuvStats(key, makeNeStats('roi-removed'));
      continue;
    }
    // eslint-disable-next-line no-await-in-loop
    await computeAndStoreRoiSuv({
      structureSetUID,
      ctSeriesUID,
      ctImageIds,
      petImageIds,
      roi,
      petVoxelVolumeMm3,
    });
  }
}
